export const getBuyerTrackingEventSubmitted = (key: string): string | null => sessionStorage.getItem(key)

export const setBuyerTrackingEventSubmitted = key => sessionStorage.setItem(key, 'true')
